<template>
	<div>
		<!-- <h2 class="text-capitalize">Categories: 
				<button type="button" class="btn btn-orange ml-2" aria-label="Close" @click="toggleTerm(slug)" v-for="slug in termSlugs" :key="slug">
					<span aria-hidden="true">&times; {{slug}}</span>
				</button>
			</h2> -->
				<h2 class="text-center">{{productHeadingTermString}}</h2>
				<p class="fz-32 text-center animated fadeIn p-64" v-if="showNoResults">No Results</p>
				<div v-if="!showNoResults && termsLoaded" class="position-relative">
					<div class="overlay bg-white text-center py-5" v-if="loading">
						<i class="fas fa-spinner fa-spin fz-50"></i>
					</div>
		<div class="container">
			<div class="row">
					<div class="content-slider-outside-wrap py-5 w-100" role="complementary" aria-label="Slider with  slides" v-for="(category_posts,category_slug) in categories" :key="category_slug">
						<div class="w-100 content-slider-inside-wrap d-flex align-items-center justify-content-center">
							<div class="col-12">
								<h4 class="ml-48">{{terms[category_slug].name}}</h4>
								<div class="content-slider slick-slider">
									<div class="content product-item" v-for="post in category_posts" :key="post.ID">
										<a class="d-block position-relative" :href="post.link" :aria-label="post.post_title">
											<div class="bg-image-wrap">
												<div class="bg-image p-20 bg-light-gray d-flex justify-content-center align-items-center">
													<img :src="post.image_url" alt="">
												</div>
											</div>
											<div class="overlay d-flex align-items-left justify-content-center flex-column px-4">
												<p class="mb-0 fz-16 text-center">Explore this model</p>
											</div>
										</a>
										<div class="py-2">
											<p class="fz-20 mb-0 ff-heading color-orange">{{post.post_title}}</p>
											<p class="mb-0 color-almost-black fz-14">{{post.dimensions}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
const axios = require('axios');
export default {
	created(){
		this.q = this.getUrlParam('q','');
		this.$set(this.termSlugs,)
		this.termSlugs = app.products.productsNavigationApp.checkedTerms = this.q.split(',');
		this.setTerms();
		this.getPosts();
		this.initSliders();
	},
	mounted(){
		// 
	},
	computed: {
		productHeadingTermString(){
			let termString = "";
			let index = 0;
			for (const [key, termSlug] of Object.entries(this.termSlugs)) {
				if(this.terms[termSlug]){
					if(index>0)	termString += " and " + this.terms[termSlug].name;
					else termString += this.terms[termSlug].name;
				}
				index++;
			}
			return termString;
		}
	},
	methods: {
		getPostRequest(page = 1, take = -1, search = ''){
			this.showNoResults = false;
			return axios.get(`${this.api.prefix}${this.api.posts}?page=${page}&take=${take}&terms=${this.termSlugs}&search=${search}&q=${this.q}`);
		},
		getPosts(page = 1, take = -1){
			this.$set(this, 'loading', true);
			this.getPostRequest(page, take)
				.then(response => {
					if(response.data.found_posts == 0 ){
						this.showNoResults = true;
					} else{
						this.$set(this, 'categories', response.data.posts);
						setTimeout(() => {
							this.initSliders();
							this.$set(this, 'loading', false);
						}, 500);
					}
				}).catch(err => {
					this.$set(this, 'loading', false);
				});
		},
		searchPosts(searchString){
			this.productHeading = "Searching all products for: " + searchString;
			// this.resetTerms();
			this.$set(this, 'q', '');
			this.$set(this, 'termSlugs', []);
			this.$set(this, 'page', 1);
			this.$set(this, 'searchString', searchString);  
			this.$set(this, 'loading', true);
			this.$set(this, 'categories', {});
			this.getPostRequest(1, -1, searchString)
				.then(response => {
					if(response.data.found_posts == 0 ){
						this.showNoResults = true;
					} else{
						this.$set(this, 'categories', response.data.posts);
						setTimeout(() => {
							this.initSliders();
							this.$set(this, 'loading', false);
						}, 100);
					}
				}).catch(err => {
					this.$set(this, 'loading', false);
				});
		},
		deleteSlug(slug){
			console.log('deleting'+slug);
		},
		resetTerms(){
			this.termSlugs = [];
			this.q = [];
			this.$set(this, 'categories', []);
			this.getPosts();
		},
		toggleTerm(slug){
			this.q = '';
			this.$set(this, 'categories', []);
			if(this.termSlugs.indexOf(slug) > -1){
				this.termSlugs.splice(this.termSlugs.indexOf(slug),1);
			}
			else{
				this.termSlugs.push(slug);
			}
			this.getPosts();
			this.sanitizeTerms();
		},
		getTermBySlug(slug){
			return axios.get(`${this.api.prefix}term/?slug=${slug}`);
		},
		setTerms(){
			axios.get(`${this.api.prefix}terms/`).then(response => {
				response.data.forEach(term => {
					this.$set(this.terms, term.slug, term);
				});
				this.$set(this, 'termsLoaded', true);
				this.sanitizeTerms();
			});
		},
		sanitizeTerms(){
			let otherTerms = Object.values(Object.assign({},this.termSlugs));
			app.products.productsNavigationApp.category_groups.forEach(function(row, index_cg, arr_cg) {
				if(index_cg<3){
					otherTerms.forEach(function(term, index, arr) {
						if(Object.values(row.categories).indexOf(term) > -1){
							arr.splice(index, 1);
						}
					}, this);
				}
			}, this);
			app.products.productsNavigationApp.category_groups[3].categories = otherTerms;
			this.termSlugs.forEach(function(term, index, arr) {
				if(!(term in this.terms)){
					arr.splice(index, 1);
				}
			}, this);
		},
		delayedInsert(subject, items){
			const [item, ...rest] = items;
			subject.push(item);
			if (rest.length > 0){
				setTimeout(() => {
					this.delayedInsert(subject, rest);
				}, 80);
			}
		},
		setMode(mode){
			this.$set(this, 'mode', mode);
		},
		json(j){
			return JSON.stringify(j);
		},
		getUrlParam(parameter, defaultvalue){
			var urlparameter = defaultvalue;
			if(window.location.href.indexOf(parameter) > -1){
				urlparameter = this.getUrlVars()[parameter];
				}
			return urlparameter;
		},
		getUrlVars() {
			var vars = {};
			var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
				vars[key] = value;
			});
			return vars;
		},
		focusUser() {
			app.products.productsNavigationApp.srAlert = "";
			let buffer = parseInt($('nav.navbar').outerHeight());
			if($('.section-products a:first-child')){
				let scrollDest = parseInt($('.section-products a:first-child').offset().top - buffer - 180);
				$('html, body').animate({
					scrollTop: scrollDest,
				}, 300);
			}
			setTimeout(function(){
				app.products.productsNavigationApp.srAlert = "Products have been updated";
				let $target = document.querySelectorAll(".section-products a");
				if($target.length > 0){
					$target[0].focus();
				}
			},301);
		},
		initSliders() {
			jQuery('.slick-slider').slick({
				infinite: true,
				slidesToScroll: 1,
				slidesToShow: 3,
				arrows: true,
				accessibility: false,
				centerMode: false,
				centerPadding: '0',
				initialSlide:0,
				speed: 400,
				useTransform: true,
				// cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
				lazyLoad: 'lazyLoad',
				variableWidth: false,
				prevArrow: "<button class='toggle a-left control-c prev slick-prev' title='Previous Slide' aria-label='Previous Slide'><i class='far fa-chevron-left' aria-hidden='true'></i></button>",
				nextArrow: "<button class='toggle a-right control-c next slick-next' title='Next Slide' aria-label='Next Slide'><i class='far fa-chevron-right' aria-hidden='true'></i></button>",
				responsive: [
					{
						breakpoint: 1024,
						settings: { 
							slidesToShow: 2,
							initialSlide:0
							}
					}, {
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							initialSlide:0
						}
					}
				]
			});
			this.focusUser();
		}
	},
	data() {
		return {
			inc: 0,
			posts: [],
			categories: {},
			// term: 'all',
			loading: true,
			api: {
				prefix: '/wp-json/usdp/v1/',
				posts: 'products_by_category/'
			},
			page: 1,
			searchString: '',
			showNoResults: true,
			termsLoaded: false,
			mode: 'grid',
			terms: {},
			termSlugs: {},
			productHeading: 'All Products',
			q: ''
		};
	}
}
</script>
